/**  @jsx jsx */
import { jsx } from 'theme-ui';
import { graphql } from 'gatsby';
import HomePage from '../components/HomePage';

export default function HomeTemplate({
  data: { exhibitor, productLists },
  pageContext,
  location,
}) {
  return (
    <HomePage
      exhibitor={exhibitor}
      brand={exhibitor}
      productLists={productLists && productLists.nodes}
      location={location}
      {...pageContext}
    />
  );
}

export const pageQuery = graphql`
  query($locale: String!) {
    ...HomePage

    productLists: allEvent(filter: { locale: { eq: $locale } }) {
      nodes {
        ...HomePage_ProductList
      }
    }
  }
`;
